import { render, staticRenderFns } from "./FrkSidebar.vue?vue&type=template&id=2bd62b12&"
import script from "./FrkSidebar.vue?vue&type=script&lang=ts&"
export * from "./FrkSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports